import React, { useState, useEffect, useContext } from "react";
import "../css/NavigationBar.css";
import airportLogo from "../../assets/images/airport-logo.png";
import appLogo from "../../assets/images/app-logo.svg";
import { BellOutlined, LogoutOutlined } from "@ant-design/icons";
import { Avatar, Badge, Dialog } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import LogoutConfirmationDialog from "./LogoutConfirmationDialog";
import ROUTE_PATHS from "../../utils/routePaths";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import useFBOApi from "../../services/api/useFBOApi";
import Loader from "./Loader";
import FBOUserProfileDialog from "./FBOUserProfileDialog";
import { StorageContext } from "../../services/StorageProvider";

const NavigationBar = () => {
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const { keycloak } = useKeycloak();
  const [showProfileDialog, setShowProfileDialog] = useState(null);
  const navigate = useNavigate();
  const { fetchNotificationsUnreadCount, fetchAllNotifications } = useFBOApi();
  const { fboUserProfileData } = useContext(StorageContext);
  const [actionCount, setActionCount] = useState(0);

  const {
    data: notificationsData,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["fbo-notifications-list", actionCount],
    queryFn: () =>
      fetchAllNotifications({
        page: 0,
        size: 4,
      }),
    enabled: !!fboUserProfileData,
    retry: false,
  });

  const { data: notificationsCount } = useQuery({
    queryKey: ["fbo-notifications-count"],
    queryFn: () => fetchNotificationsUnreadCount(),
    enabled: !!fboUserProfileData,
    retry: false,
    refetchInterval: 30000,
  });

  useEffect(() => {
    setActionCount(actionCount + 1);
  }, [showNotifications]);

  const handleLogoutClick = () => {
    setShowLogoutDialog(true);
  };

  const handleLogoutDialogClose = () => {
    setShowLogoutDialog(false);
  };

  const handleLogoutDialogSave = () => {
    sessionStorage.clear();
    keycloak.logout();
  };

  const handleNotificationClick = () => {
    if (window.location.pathname !== ROUTE_PATHS.NOTIFICATIONS) {
      navigate(ROUTE_PATHS.NOTIFICATIONS);
    }
    setShowNotifications(false);
  };

  return (
    <div className="nav-bar">
      <div className="left-container">
        <img src={airportLogo} className="airport-logo" alt="logo" />
        <img src={appLogo} className="app-logo" alt="logo" />
      </div>
      <div className="center-container">
        <h1>Airport Vendor Management</h1>
      </div>
      <div className="right-container">
        {fboUserProfileData ? (
          <>
            <Avatar
              alt={fboUserProfileData.id}
              className="profile-pic"
              onClick={() => setShowProfileDialog(true)}
            >
              {fboUserProfileData.firstName.charAt(0)}
            </Avatar>
            <div
              onClick={() => setShowProfileDialog(true)}
            >{`${fboUserProfileData.firstName} ${fboUserProfileData.lastName}`}</div>
          </>
        ) : null}
        <Badge
          badgeContent={
            notificationsCount?.data > 99 ? "99+" : notificationsCount?.data
          }
          color="primary"
        >
          <BellOutlined
            style={{ marginLeft: "35px" }}
            onClick={() => setShowNotifications(!showNotifications)}
          />
        </Badge>
        <Dialog
          open={showNotifications}
          onClose={() => setShowNotifications(false)}
          slotProps={{
            backdrop: {
              style: {
                backgroundColor: "transparent",
              },
            },
          }}
          PaperProps={{
            style: {
              position: "absolute",
              top: "50px",
              right: "80px",
              width: "300px",
              margin: 0,
            },
          }}
        >
          <div>
            {isLoading ? (
              <Loader />
            ) : error && error.status === 404 ? (
              <div className="notification-screen-no-data">
                No notifications founds
              </div>
            ) : notificationsData?.data &&
              notificationsData?.data?.length === 0 ? (
              <div className="notification-screen-no-data">
                No notifications found
              </div>
            ) : (
              <div>
                {notificationsData?.data?.content?.map((item) => (
                  <div
                    key={item?.id}
                    className={`navigation-notification-item ${item?.isRead ? "" : "notification-unread"
                      }`}
                    onClick={handleNotificationClick}
                  >
                    <div className="navigation-notification-content">
                      <div className="navigation-notification-message">
                        {item?.notification}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="navigation-notification-footer">
              <span
                className="navigation-notification-view-all"
                onClick={handleNotificationClick}
              >
                View all
              </span>
            </div>
          </div>
        </Dialog>
        <LogoutOutlined
          style={{
            marginLeft: "35px",
            cursor: "pointer",
            fontSize: "20px",
            position: "relative",
            zIndex: 2,
          }}
          onClick={handleLogoutClick}
        />
      </div>
      <LogoutConfirmationDialog
        open={showLogoutDialog}
        onClose={handleLogoutDialogClose}
        onSave={handleLogoutDialogSave}
      />
      <FBOUserProfileDialog
        open={showProfileDialog}
        onClose={() => setShowProfileDialog(false)}
      />
    </div>
  );
};

export default NavigationBar;
